// SearchSelect ↔ SearchMultiSelect ortak çekirdeği (TODO-KPI-140/1): süzme + "+N daha" metni ve
// liste klavye kararı TEK yerde — iki seçici aynı kuralı kullanır, biri kayarsa diğeri de kayar.

import { filterSearchOptions } from "../../lib/search-select";

/** Kırpılan sonuç satırı metni ("+3 daha"). */
export function moreText(n: number): string {
  return `+${n.toString()} daha`;
}

export interface SearchCoreOptions<T> {
  items: readonly T[];
  query: string;
  keyOf: (item: T) => string;
  labelOf: (item: T) => string;
  codeOf?: ((item: T) => string | undefined) | undefined;
  hintOf?: ((item: T) => string | undefined) | undefined;
  /** en çok gösterilen sonuç (varsayılan 200) */
  max?: number | undefined;
}

/** Aynı süzme kademeleri (`filterSearchOptions`); `more` = sınır yüzünden gösterilmeyen eşleşme sayısı. */
export function searchSelectCore<T>(opts: SearchCoreOptions<T>): { visible: T[]; more: number } {
  const max = opts.max ?? 200;
  const byKey = new Map<string, T>();
  const options = opts.items.map((it) => {
    const value = opts.keyOf(it);
    byKey.set(value, it);
    const code = opts.codeOf?.(it);
    const hint = opts.hintOf?.(it);
    return {
      value,
      label: opts.labelOf(it),
      ...(code !== undefined ? { code } : {}),
      ...(hint !== undefined ? { hint } : {}),
    };
  });
  const all = filterSearchOptions(opts.query, options, Number.POSITIVE_INFINITY);
  const visible = all.slice(0, max).map((o) => byKey.get(o.value)!);
  return { visible, more: Math.max(0, all.length - max) };
}

export type ListKeyAction = number | "select" | "close" | null;

/**
 * Liste (combobox) tuşları: ↑/↓ bir satır, Home/End uçlar → yeni etkin indeks; Enter → "select";
 * Esc/Tab → "close"; başka tuş null. (Çoklu kipte boş aramada Space ayrıca "select" sayılır —
 * çağıran karar verir.)
 */
export function listKeyAction(key: string, index: number, count: number): ListKeyAction {
  switch (key) {
    case "ArrowDown":
      return Math.min(Math.max(0, count - 1), index + 1);
    case "ArrowUp":
      return Math.max(0, index - 1);
    case "Home":
      return 0;
    case "End":
      return Math.max(0, count - 1);
    case "Enter":
      return "select";
    case "Escape":
    case "Tab":
      return "close";
    default:
      return null;
  }
}
